/**
 * Customer-note wire ⇄ domain mappers.
 *
 * The customer-service `CustomerNoteResponse` schema is a flat snake_case object
 * that maps 1:1 to the UI camelCase shape, so the generic deep converter handles
 * it. `customer_id` arrives as an int → coerce to string for the UI.
 */

import { toCamelDeep } from '@/services/http/caseMap'
import type { CustomerNote } from '@/types/note.types'

function unwrapList(raw: unknown): Record<string, unknown>[] {
  const arr = Array.isArray(raw) ? raw : ((raw as { items?: unknown[] })?.items ?? [])
  return arr as Record<string, unknown>[]
}

export function mapNoteFromApi(raw: Record<string, unknown>): CustomerNote {
  const note = toCamelDeep<CustomerNote>(raw)
  return {
    ...note,
    id: String(note.id),
    customerId: note.customerId != null ? String(note.customerId) : note.customerId,
  }
}

export function mapNoteListFromApi(raw: unknown): CustomerNote[] {
  return unwrapList(raw).map(mapNoteFromApi)
}
